module.exports = __webpack_public_path__ + "img/account_circle.3d4c331c.svg";